<template>
  <b-modal
    :id="modalName"
    modal-class="mc-modal-link"
    :title="title"
    size="md"
    centered
    scrollable
  >
    <p class="mc-paragraph">{{ $t('fleetTask.share.text') }}</p>
    <b-list-group class="mc-general__label">
      <b-list-group-item href="#" @click="copyLink">
        <i class="mc-icon fas fa-link me-1"></i>
        <span class="mc-general__label">{{ $t('global.action.copyLink') }}</span>
      </b-list-group-item>
      <b-list-group-item href="#" @click="redirect">
        <i class="mc-icon icon-outline_map me-1"></i>
        <span class="mc-general__label">{{ $t('global.action.share.viewTracking') }}</span>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer="{ cancel }">
      <b-button size="md" variant="outline-primary" @click="cancel()">
        {{ $t('global.action.cancel') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { MixPanel } from '@/mixin/mixpanel'

export default {
  mixins: [MixPanel],
  props: {
    modalName: {
      type: String,
      required: true,
    },
    number: {
      type: String,
    },
    trackLink: {
      type: String,
    },
  },
  computed: {
    title() {
      return `${this.$t('fleetTask.share.title')} "${this.number}"`
    }
  },
  methods: {
    copyLink() {
      this.track('FO Quick Assignment Copy Link Clicked')

      navigator.clipboard.writeText(this.trackLink)
      this.$mcToast.success(this.$t('fleetTaskInstant.share.success'))
      this.$bvModal.hide(this.modalName)
    },
    redirect() {
      const url = this.trackLink
      window.open(url, '_blank')
      this.$bvModal.hide(this.modalName)
    },
  },
}
</script>
